import styled from "styled-components";
import { colors } from "../../../utils";

export const CenterWrapper = styled.div`
  background-color: ${colors.white};
  border-radius: 10px;
  padding: 3vw;
`;

export const ContentHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
`;

export const HeaderIcon = styled.img`
  margin-right: 10px;
  width: 40px;
  height: 40px;
`;

export const BillingTitle = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
  border-radius: 8px;
`;

export const CardContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 24px;
    flex: 1;
`

export const SingleCard = styled.div`
    display: flex;
    gap: 8px;
    flex-direction: column;
    flex: 0.5;
`

export const CardSubContainer = styled.div`
    display: flex;
    justify-content: space-between;
`

export const CardHeading = styled.div`
    font-size: ${props => (props.fontSize || "16px")};
    line-height: 20px;
    font-weight: ${props => (props.fontWeight || 700)};
    font-family: "DM Sans", sans-serif;
    color: #123051;
`

export const InternalHeading = styled.div`
    font-size: 20px;
    line-height: 20px;
    font-weight: 700;
    font-family: "DM Sans", sans-serif;
    color: #123051;
`

export const PlanInfoContainer = styled.div`
    display: flex;
    border-radius: 8px;
    padding: 24px 40px 24px 40px;
    gap: 24px;
    border: 1px solid #E1E1E1;
    justify-content: space-between;
    height: ${props => (props.hasCard ? "134px" : "176px")};
`

export const PlanHeadingContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 1px;
`

export const NoCardContainer = styled.div`
    border: 1px solid #E1E1E1;
    padding: 24px;
    border-radius: 8px;
    justify-content: center;
    align-items: center;
`

export const SubContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
`

export const Duration = styled.div`
    border-radius: 100px;
    background-color: #E3EFEB;
    padding: 4px 8px 4px 8px;
    height: fit-content;
`

// export const Card = styled.div`
//     display: flex;
//     justify-content: space-between;
//     border-radius: 8px;
//     border: 1px solid #CED4DA;
//     padding: 24px;
//     background: conic-gradient(from 180deg at 50% 50%, #F5EEDE -41.73deg, #F7FED5 53.81deg, #CCFEFF 133.87deg, #FDCFFE 244.39deg, #F5EEDE 318.27deg, #F7FED5 413.81deg);
// `

export const CardInfo = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
`

export const EditButton = styled.div`
    color: #9B5AF8;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    font-family: "DM Sans", sans-serif;
    cursor: pointer;
`

export const TableContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 20px;
`

export const TableHeadingContainer = styled.div`
    display: flex;
    justify-content: space-between;
`

export const BillingPrice = styled.div`
    font-size: 32px;
    font-weight: 700;
    line-height: 41.66px;
    font-family: "DM Sans", sans-serif;
    color: #565556;
`

export const CardHeadingContainer = styled.div`
    display: flex;
    justify-content: space-between;
`

export const LoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
`

export const AddPaymentButton = styled.div`
    display: flex;
    align-self: center;
    width: 190px;
`

export const FilterContainer = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
`

export const PlanName = styled.div`
  display: flex;
  gap: 8px;
  align-items: ${props => (props.hasDueDate ? 'center' : 'normal')};
`;

export const ChangePlanText = styled.div`
    font-family: "DM Sans", sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: ${colors.PrimaryPurple500};
    cursor: pointer;
    text-align: end;
`

export const SecurePaymentText = styled.div`
    font-family: "DM Sans", sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: ${colors.textBlue};
    letter-spacing: 0%;
    text-align: center;
    width: 340px;
`

export const StyledSubscriptionRowItem = styled.div`
  display: flex;
  border-radius: 2px;
  padding: 4px 8px 4px 8px;
  background-color: ${props => props.backgroundColor};
  color: ${props => props.textColor};
`;